export class EventBus {
	
	public on(name:string, fn:any){
		if(!this._listeners[name]){
			this._listeners[name] = [];
		}
		this._listeners[name].push(fn);
	};

	public off(name:string, fn:any){
		if(!this._listeners[name]){
			let i = this._listeners[name].findIndex((v:any) => v && v === fn);
			if(i > -1){ this._listeners[name].splice(i, 1); }
			if(this._listeners[name].length === 0){
				this._listeners[name] = undefined;
			}
		}
	};

	public emit(name:string, data:any){
		if(this._listeners[name]){
			this._listeners[name].forEach((l:any) => l(data));
		}
	};

	private _listeners:any = {};
}